import { AuxNotificationStyleEnum, AuxNotificationToastTypeEnum } from "@blk/aladdin-web-components";
import { createSelector } from "@reduxjs/toolkit";
import * as httpStatus from "http-status-codes";
import { InsCancelEditDialogAction } from "components/dialogs/insCancelEditActionDialog";
import { InsCashflowExportDialogAction } from "components/dialogs/InsCashflowExportDialogAction";
import { InsDefaultDialogAction } from "components/dialogs/insDefaultDialogAction";
import { InsDeleteAnalysisDialogAction } from "components/dialogs/InsDeleteAnalysisDialogAction";
import { InsDeleteBenchmarkDialogAction } from "components/dialogs/InsDeleteBenchmarkDialogAction";
import { InsDeleteNoteDialogAction } from "components/dialogs/insDeleteNoteDialogAction";
import { InsDeletePortfolioDialogAction } from "components/dialogs/insDeletePortfolioDialogAction";
import { InsDeletePortfolioFromEditButtonDialogAction } from "components/dialogs/InsDeletePortfolioFromEditButtonDialogAction";
import { InsDeletePrivateBenchmarkDialogAction } from "components/dialogs/InsDeletePrivateBenchmarkDialogAction";
import { InsDeletePublicEquityIndicesDialogAction } from "components/dialogs/InsDeletePublicEquityIndicesDialogAction";
import { InsDeleteWorkspaceDialogAction } from "components/dialogs/insDeleteWorkspaceDialogAction";
import { InsPortfolioEditionStepTwoDialogAction } from "components/dialogs/InsPortfolioEditionStepTwoDialogAction";
import { InsResetBenchmarkDialogAction } from "components/dialogs/InsResetBenchmarkDialogAction";
import { InsDeleteFundSeriesDialogAction } from "components/dialogs/InsDeleteFundSeriesDialogAction";
import { InsUnSavedChangesAction } from "components/modal/unsaved-changes/insUnsavedChangesAction";
import { InsDeleteImportDataDialogAction } from "components/dialogs/InsDeleteImportDataDialogAction";
import { InsDeletePacingPlanDialogAction } from "components/dialogs/insDeletePacingPlanDialogAction";
export var MessagesDialogFunctionName;
(function (MessagesDialogFunctionName) {
    MessagesDialogFunctionName[MessagesDialogFunctionName["Default"] = 0] = "Default";
    MessagesDialogFunctionName[MessagesDialogFunctionName["CancelEdit"] = 1] = "CancelEdit";
    MessagesDialogFunctionName[MessagesDialogFunctionName["DeletePacingPlan"] = 2] = "DeletePacingPlan";
    MessagesDialogFunctionName[MessagesDialogFunctionName["DeleteWorkspace"] = 3] = "DeleteWorkspace";
    MessagesDialogFunctionName[MessagesDialogFunctionName["DeleteBenchmark"] = 4] = "DeleteBenchmark";
    MessagesDialogFunctionName[MessagesDialogFunctionName["DeletePortfolio"] = 5] = "DeletePortfolio";
    MessagesDialogFunctionName[MessagesDialogFunctionName["DeleteAnalysis"] = 6] = "DeleteAnalysis";
    MessagesDialogFunctionName[MessagesDialogFunctionName["CashflowExportButton"] = 7] = "CashflowExportButton";
    MessagesDialogFunctionName[MessagesDialogFunctionName["CancelEditHeader"] = 8] = "CancelEditHeader";
    MessagesDialogFunctionName[MessagesDialogFunctionName["DeletePortfolioFromEditButton"] = 9] = "DeletePortfolioFromEditButton";
    MessagesDialogFunctionName[MessagesDialogFunctionName["PortfolioEditionStepTwo"] = 10] = "PortfolioEditionStepTwo";
    MessagesDialogFunctionName[MessagesDialogFunctionName["PrivateEquityBenchmarkContent"] = 11] = "PrivateEquityBenchmarkContent";
    MessagesDialogFunctionName[MessagesDialogFunctionName["PublicEquityIndicesContent"] = 12] = "PublicEquityIndicesContent";
    MessagesDialogFunctionName[MessagesDialogFunctionName["ResetBenchmark"] = 13] = "ResetBenchmark";
    MessagesDialogFunctionName[MessagesDialogFunctionName["DeleteNote"] = 14] = "DeleteNote";
    MessagesDialogFunctionName[MessagesDialogFunctionName["DeleteFundSeries"] = 15] = "DeleteFundSeries";
    MessagesDialogFunctionName[MessagesDialogFunctionName["UnSavedChanges"] = 16] = "UnSavedChanges";
    MessagesDialogFunctionName[MessagesDialogFunctionName["DeleteImportData"] = 17] = "DeleteImportData";
})(MessagesDialogFunctionName || (MessagesDialogFunctionName = {}));
export const dialogsList = new Map([
    [MessagesDialogFunctionName.DeletePacingPlan, { action: InsDeletePacingPlanDialogAction, isOpened: false }],
    [MessagesDialogFunctionName.DeletePortfolio, { action: InsDeletePortfolioDialogAction, isOpened: false }],
    [MessagesDialogFunctionName.DeleteAnalysis, { action: InsDeleteAnalysisDialogAction, isOpened: false }],
    [MessagesDialogFunctionName.CancelEdit, { action: InsCancelEditDialogAction, isOpened: false }],
    [MessagesDialogFunctionName.DeleteWorkspace, { action: InsDeleteWorkspaceDialogAction, isOpened: false }],
    [MessagesDialogFunctionName.DeleteBenchmark, { action: InsDeleteBenchmarkDialogAction, isOpened: false }],
    [MessagesDialogFunctionName.DeleteNote, { action: InsDeleteNoteDialogAction, isOpened: false }],
    [MessagesDialogFunctionName.CashflowExportButton, { action: InsCashflowExportDialogAction, isOpened: false }],
    [MessagesDialogFunctionName.DeletePortfolioFromEditButton, { action: InsDeletePortfolioFromEditButtonDialogAction, isOpened: false }],
    [MessagesDialogFunctionName.PortfolioEditionStepTwo, { action: InsPortfolioEditionStepTwoDialogAction, isOpened: false }],
    [MessagesDialogFunctionName.PrivateEquityBenchmarkContent, { action: InsDeletePrivateBenchmarkDialogAction, isOpened: false }],
    [MessagesDialogFunctionName.PublicEquityIndicesContent, { action: InsDeletePublicEquityIndicesDialogAction, isOpened: false }],
    [MessagesDialogFunctionName.ResetBenchmark, { action: InsResetBenchmarkDialogAction, isOpened: false }],
    [MessagesDialogFunctionName.Default, { action: InsDefaultDialogAction, isOpened: false }],
    [MessagesDialogFunctionName.DeleteFundSeries, { action: InsDeleteFundSeriesDialogAction, isOpened: false }],
    [MessagesDialogFunctionName.UnSavedChanges, { action: InsUnSavedChangesAction, isOpened: false }],
    [MessagesDialogFunctionName.DeleteImportData, { action: InsDeleteImportDataDialogAction, isOpened: false }]
]);
const getNotificationId = (type, id, modals) => {
    const [modalName] = Object.values(modals || {})
        .map((m) => m)
        .filter((m) => m?.isOpen)
        .map((m) => m.content.modalName.toString()) || [];
    if (modalName) {
        return `modal-${modalName}-${type}-${id}`;
    }
    return `${type}-${id}`;
};
const NOTIFICATION_RECENT_TIMEOUT_MS = 5000;
const queriesSelector = (state) => state.customQueries;
const modalsSelector = (state) => state.modals;
const notificationsSelector = (state) => state.notifications;
const isActiveNotication = (item) => Boolean(item?.pendingMessage) && !item.isFinished;
const notificationGroupConfigs = (time) => [
    {
        filterFn: (x) => isActiveNotication(x),
        idSelector: (item) => Object.keys(item).filter((x) => isActiveNotication(item[x]))?.[0] ?? "",
        key: "activeNotifications",
        messageKey: "pendingMessage",
        style: AuxNotificationStyleEnum.MESSAGE,
        toastType: AuxNotificationToastTypeEnum.PERSISTENT
    },
    {
        filterFn: (item) => Boolean(item?.successMessage) &&
            item.isFinished &&
            item.lastUpdated && item.lastUpdated > time &&
            item.status && item.status < httpStatus.BAD_REQUEST,
        idSelector: (item) => Object.keys(item).length.toString(),
        key: "successNotifications",
        messageKey: "successMessage",
        style: AuxNotificationStyleEnum.SUCCESS,
        toastType: AuxNotificationToastTypeEnum.TIMEOUT
    },
    {
        filterFn: (item) => Boolean(item?.errorMessage) &&
            item.isFinished &&
            item.lastUpdated && item.lastUpdated > time &&
            item.status && item.status >= httpStatus.BAD_REQUEST,
        idSelector: (item) => Object.keys(item).length.toString(),
        key: "failedNotifications",
        messageKey: "errorMessage",
        style: AuxNotificationStyleEnum.ERROR,
        toastType: AuxNotificationToastTypeEnum.TIMEOUT
    }
];
const generateNotificationGroups = (queriesState, modalsState, time) => {
    if (!queriesState) {
        return [];
    }
    return notificationGroupConfigs(time).reduce((acc, config) => {
        const keys = Object.keys(queriesState).filter((key) => config.filterFn(queriesState[key]));
        if (keys.length > 0) {
            acc.push({
                id: getNotificationId(config.key, config.idSelector(queriesState), modalsState),
                message: keys.map((key) => queriesState[key][config.messageKey]),
                notificationStyle: config.style,
                showMessageCount: false,
                toastType: config.toastType
            });
        }
        return acc;
    }, []);
};
const transform = (queriesState, modalsState, notificationsState) => {
    const time = Math.floor(Date.now()) - NOTIFICATION_RECENT_TIMEOUT_MS;
    const notifGroups = generateNotificationGroups(queriesState, modalsState, time);
    const recentNotifications = notificationsState.filter((notif) => parseInt(notif.id, 10) >= time);
    return [...notifGroups, ...recentNotifications];
};
export const selectNotificationsSelector = createSelector(queriesSelector, modalsSelector, notificationsSelector, transform);
